import { render, staticRenderFns } from "./MenuItemComponent.vue?vue&type=template&id=536ed482"
import script from "./MenuItemComponent.vue?vue&type=script&lang=js"
export * from "./MenuItemComponent.vue?vue&type=script&lang=js"
import style0 from "./MenuItemComponent.vue?vue&type=style&index=0&id=536ed482&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports